export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_SELECTED_BSA = "UPDATE_SELECTED_BSA";
export const UPDATE_LEVEL = "UPDATE_LEVEL";
export const UPDATE_SELECTED_COUNTRYCODE = "UPDATE_SELECTED_COUNTRYCODE";
export const UPDATE_DT_ACCESS = "UPDATE_DT_ACCESS";
export const UPDATE_ADMIN_ACCESS = "UPDATE_ADMIN_ACCESS";
export const UPDATE_UCUBE_ACCESS = "UPDATE_UCUBE_ACCESS";
export const UPDATE_OPSREPORT_ACCESS = "UPDATE_OPSREPORT_ACCESS";
export const ADD_CHANGED_OUTLETSTATUS = 'ADD_CHANGED_OUTLETSTATUS';
export const REMOVE_CHANGED_OUTLETSTATUS = 'REMOVE_CHANGED_OUTLETSTATUS';
export const CLEAR_CHANGED_OUTLETSTATUSES = 'CLEAR_CHANGED_OUTLETSTATUSES';